import React from 'react'
// import FormRegisterTH from './thailand/FormRegister'
// import FormRegisterIN from './india/FormRegister'
import FormElements from './FormElements'

const FormPortal = (props) => {
    const { country = 'US' } = props

    const Form = React.useMemo(() => {
        switch (country) {
            // case 'TH':
            //     return <FormRegisterTH {...props} />
            // case 'IN':
            //     return <FormRegisterIN {...props} />

            default:
                return <FormElements {...props} />
        }
    }, [country])

    return Form
}

export default FormPortal



// WEBPACK FOOTER //
// ./src/components/StartContainer/FormCountries/FormPortal.js